import AlertsPage from "components/pages/AlertsPage";

export default function CaptureAlertsDefaultScreen(props) {
    return <AlertsPage />;
}